import type { QaPlace } from "@CommonApi/merchflows/_merchflowId_/qa";
import { routeToUrl } from "@CommonUtils/routes";
import { withStudioWizard } from "src/pages/CdtStudio/store/atoms";
import { pages } from "src/utils/pages";
import { O_ADJUST_PARAM } from "../components/OVerdict";

/**
 * Where a place O names opens. Null for `data`, which has no page. The rules
 * modal opens with O's adjust view and nothing applied.
 */
export const qaPlaceUrlOf = (merchflowId: number, place: QaPlace): string | null => {
  switch (place.kind) {
    case "base_pog":
    case "rules":
    case "cdt_studio": {
      const basePog = routeToUrl(
        pages.merchflows_merchflowId_BasePog_basePogId_,
        { merchflowId, basePogId: place.basePogId },
        place.kind === "rules" ? { [O_ADJUST_PARAM]: 1 } : undefined,
      );
      return place.kind === "cdt_studio" ? withStudioWizard(basePog) : basePog;
    }
    case "stores":
      return routeToUrl(
        pages.merchflows_merchflowId_StoresAll,
        { merchflowId },
        { store_pog_trigger_id: place.storePogTriggerId },
      );
    case "store_pog":
      return routeToUrl(pages.merchflows_merchflowId_Stores_storeCode_Pogs_storePogId_, {
        merchflowId,
        storeCode: place.storeCode,
        storePogId: place.storePogId,
      });
    case "data":
      return null;
  }
};
